import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/bluetooth-landing/enCopy";

const MobileAppWithBluetoothPage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/mobile-app-with-bluetooth",
      lang: "en",
      ogLocale: "en_US",
      structuredData: copy.structuredData,
    }}
    alternateLanguage={{
      href: "/aplikacje-bluetooth",
      label: "PL",
    }}
    navbarCopy={copy.navbarCopy}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default MobileAppWithBluetoothPage;
